/**
 * Site Entry Point for Parent and Child Theme Core
 */

/* ======== Global NPM Packages for Parent Theme Usage ======== */
//global.jQuery = require('jquery');
// Owl Carousel
import 'owl.carousel/dist/owl.carousel.min.js';
import 'owl.carousel/dist/assets/owl.carousel.min.css';
import 'owl.carousel/dist/assets/owl.theme.default.min.css';

// Lightbox2
import 'lightbox2/dist/js/lightbox.min.js';
import 'lightbox2/dist/css/lightbox.min.css';

// General JS Utilities
import './js/bootstrap-general';
import './js/header-5';
// Prism js
import './js/prism';
// Admnin JS
import './js/admin';

// Iconify
import Iconify from '@iconify/iconify';

// Bootstrap JS
import * as bootstrap from 'bootstrap';
// Nootstrap Modal
import 'bootstrap/js/dist/modal';

/* ======== Parent & Child Theme Sass & JS  ======== */
import './../../../../bidmark-dev-child/assets/src/site/index.js';
